import React from 'react';
import './Home.css';
import Hero from '../../components/Hero/Hero';
import Services from '../../components/Services/Services';

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">Nossos Serviços</h2>
          <Services />
        </div>
      </section>
    </div>
  );
};

export default Home;